import React from 'react';
import { useMap } from 'react-leaflet';
import { Button } from '@mui/material';
import MyLocationIcon from '@mui/icons-material/MyLocation';

const CurrentLocationButton = ({
  setCurrentPosition,
}: {
  setCurrentPosition: React.Dispatch<React.SetStateAction<{ lat: number; lng: number }>>;
}) => {
  const map = useMap();

  const handleClick = () => {
    navigator.geolocation.getCurrentPosition(
      (position) => {
        const newPosition = {
          lat: position.coords.latitude,
          lng: position.coords.longitude,
        };
        
        console.log('Updated position:', newPosition);
        
        // Update the current position in the parent component
        setCurrentPosition(newPosition);
        
        // Move the map to the new position
        map.setView([newPosition.lat, newPosition.lng], map.getZoom());
      },
      (error) => {
        console.error('Error fetching current position iz CurrentLocationButton:', error);
      },
      { enableHighAccuracy: true, timeout: 10000, maximumAge: 0 }
    );
  };

  return (
    <Button
      variant="contained"
      color="primary"
      onClick={handleClick}
      style={{
        position: 'absolute',
        //bottom: '10px',
        top: '10px',
        //right: '10px',
        right: '2px',
        zIndex: 9999999 }}
    >
      <MyLocationIcon />
    </Button>
    //  <div
    //   style={{
    //     position: 'absolute',
    //     top: '10px',
    //     right: '2px',
    //     zIndex: 9999999,
    //     pointerEvents: 'auto', // Ensure the button can capture pointer events
    //   }}
    // >
    //   <Button
    //     variant="contained"
    //     color="primary"
    //     onClick={handleClick}
    //     style={{
    //       display: 'flex',
    //       alignItems: 'center',
    //       justifyContent: 'center',
    //     }}
    //   >
    //     <MyLocationIcon />
    //   </Button>
    // </div>
  );
};

export default CurrentLocationButton;